import styled from 'styled-components';
import appTheme from '../../../../themes/Theme';
import TextField from '@material-ui/core/TextField';
import {
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';

export const StyledTextField = styled(TextField)`
  & input {
    color: ${(props) => (props.error ? '#f44336' : appTheme.textColor)};
    ::-webkit-calendar-picker-indicator {
      filter: ${appTheme.datePickerColor};
    }
  }
  & label,
  label.Mui-focused {
    color: ${(props) => (props.error ? '#f44336' : '#38c2a0')};
  }
  & .MuiInput-underline:before {
    border-bottom-color: ${(props) => (props.error ? '#f44336' : '#38c2a0')};
  }
  & .MuiInput-underline:after {
    border-bottom-color: ${(props) => (props.error ? '#f44336' : '#38c2a0')};
  }
  & .MuiInput-underline:hover:not(.Mui-disabled):before {
    border-bottom-color: ${(props) => (props.error ? '#f44336' : '#38c2a0')};
  }
`;

export const StyledKeyboardTimePicker = styled(KeyboardTimePicker)`
  & label,
  label.Mui-focused {
    color: ${(props) => (props.error ? '#f44336' : '#38c2a0')};
  }
  & .MuiInput-underline:before {
    border-bottom-color: ${(props) => (props.error ? '#f44336' : '#38c2a0')};
  }
  & .MuiInput-underline:after {
    border-bottom-color: ${(props) => (props.error ? '#f44336' : '#38c2a0')};
  }
  & .MuiInput-underline:hover:not(.Mui-disabled):before {
    border-bottom-color: ${(props) => (props.error ? '#f44336' : '#38c2a0')};
  }

  & .MuiIconButton-label > svg {
    color: ${appTheme.textColor};
  }
  & .MuiInputBase-root > input {
    color: ${(props) => (props.error ? '#f44336' : appTheme.textColor)};
  }
  & .MuiFormLabel-root.Mui-disabled{
    color: gray;
  }
`;

export const StyledKeyboardDatePicker = styled(KeyboardDatePicker)`
  & label,
  label.Mui-focused {
    color: ${(props) => (props.error ? '#f44336' : '#38c2a0')};
  }
  & .MuiInput-underline:before {
    border-bottom-color: ${(props) => (props.error ? '#f44336' : '#38c2a0')};
  }
  & .MuiInput-underline:after {
    border-bottom-color: ${(props) => (props.error ? '#f44336' : '#38c2a0')};
  }
  & .MuiInput-underline:hover:not(.Mui-disabled):before {
    border-bottom-color: ${(props) => (props.error ? '#f44336' : '#38c2a0')};
  }

  & .MuiIconButton-label > svg {
    color: ${appTheme.textColor};
  }
  & .MuiInputBase-root > input {
    color: ${(props) => (props.error ? '#f44336' : appTheme.textColor)};
  }
  & .MuiFormLabel-root.Mui-disabled{
    color: gray;
  }
`;
